var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabBarChatDefault = function SvgTabBarChatDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303742",
    d: "M12 2c5.523 0 10 4.477 10 10v8.182A1.82 1.82 0 0 1 20.182 22H12C6.477 22 2 17.523 2 12S6.477 2 12 2m0 1.2A8.8 8.8 0 0 0 3.2 12a8.8 8.8 0 0 0 8.8 8.8h8.182a.62.62 0 0 0 .618-.618V12A8.8 8.8 0 0 0 12 3.2m3.477 4.154a.5.5 0 0 1 .335.623l-.556 1.856H17a.5.5 0 0 1 0 1h-2.045l-.7 2.333h1.912a.5.5 0 0 1 0 1h-2.21l-.645 2.144a.5.5 0 0 1-.957-.287l.556-1.857H9.79l-.643 2.144a.5.5 0 1 1-.959-.287l.557-1.857H7a.5.5 0 1 1 0-1h2.045l.7-2.333H7.832a.5.5 0 0 1 0-1h2.21l.645-2.144a.5.5 0 0 1 .957.288l-.556 1.856h3.122l.643-2.144a.5.5 0 0 1 .623-.335m-5.388 5.812h3.123l.7-2.333h-3.124z"
  })));
};
export default SvgTabBarChatDefault;